import { render, staticRenderFns } from "./threeGrids.vue?vue&type=template&id=0edec1f3&scoped=true&"
import script from "./threeGrids.vue?vue&type=script&lang=js&"
export * from "./threeGrids.vue?vue&type=script&lang=js&"
import style0 from "./threeGrids.vue?vue&type=style&index=0&id=0edec1f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edec1f3",
  null
  
)

export default component.exports